<template >
  <v-layout row justify-center>
    <v-dialog v-model="show_dialog" persistent max-width="500px">
      <v-card>
        <v-card-title primary-title class="headline info lighten-2">
          <span class="headline">会员充值</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form">  
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="mobile" label="会员号"  disabled ></v-text-field>
              </v-flex>  
              <v-flex xs12 sm6 md6>
                <v-text-field v-model="name" label="姓名"  hide-details disabled></v-text-field>
              </v-flex>
              <hr>
              <v-flex xs12 sm12 md12>
                <v-select
                    v-model="selected_type"
                    :items="recharge_types"
                    item-value="_id"
                    item-text="text"
                    no-data-text="充值类型"
                    clearable
                    class="import_input"
                  ></v-select>
              </v-flex>
             <!--  <v-flex xs12 sm6 md6>
                <v-text-field v-model="money" class="import_input" label="充值金额" autocomplete="off" clearable  hide-details ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field v-model="ext"  class="import_input" label="赠送金额" autocomplete="off" clearable  hide-details ></v-text-field>
              </v-flex> -->



              <v-flex xs12>
                <v-text-field v-model="note" label="备注" clearable   ></v-text-field>
              </v-flex>
            </v-layout>
            </v-form> 
          </v-container>
          <!-- <small>*indicates  field</small> -->
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <!-- {{money}} - {{ext}} - {{note}} -->
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="show_dialog = false">取消</v-btn>
          <v-btn 
            :loading="doing"
            :disabled="doing"
            color="blue darken-1" flat @click.native="create_record">充值</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {base_api} from "@/api/base_api"   
import {selectoption} from "@/api/module/select_options"  

export default {
    //template:``,
    name: '',
    props:{
        width:{
            type:String,
            default:'500px'
        }
    },
    computed:{
        show_dialog:{
          get(){
              return this.$store.state.dialog.show_vip_recharge_dialog;
          },
          set(val){
              this.$store.commit('SHOW_DIALOG_VIP_RECHARGE',val)
          }
        },
        vip_info(){
            return this.$store.state.vip.vip
        }
    },
    methods:{
      get_recharge_type(){
        console.log("NEED GET SYSUSER LIST");
        return selectoption({oper:'recharge_type',key:"_id",value:"money,ext,note,start_tm,end_tm",type:'obj',skipp:'shop_id'}).then(resp=>{
            this.recharge_types = resp.data;
            this.recharge_types.map(it=>{
                   it.text = `充${it.money} 送${it.ext}`
            })
        }).catch(err=>{
          console.log(err);
                debugger
        })
      },
      // input_change(val){
      //     let input = parseFloat(val);
      //     if(isNaN(input)) return this.money = 0;
      //     this.money = input
      // },
      // value_update(val){
      //     this.money = parseFloat(val);
      //     console.log(val);
      // },
        empty_value(){
            this.mobile           = this.vip_info.mobile;
            this.name             = this.vip_info.name;
            this.money            = 0;
            this.ext              = 0;
            this.note             = "";
            this.selected_type   = null;
        },
        create_record(){
            console.log("click")
            let self = this;
            let re_money = parseFloat(self.money);
            let re_ext   = parseFloat(self.ext);

            if(isNaN(re_money)||isNaN(re_ext) || re_money+re_ext == 0){
              return self.$notify({
                      group: 'msgpad',
                      type: 'error',
                      title: '操作失败！',
                      text: "金额填写错误"
                  })
            }
            self.money = re_money;
            self.ext   = re_ext;
            let conf   = {
              money  :re_money,
              ext    :re_ext,
              mobile :this.vip_info.mobile,
              name   :this.vip_info.name,
              type   :'recharge',
              note   :self.note,
              callback:()=>{
                 debugger
                 console.log("OK")
              }
            }
            self.$emit('recharge',conf);
            self.doing = true;
            // self.$store.commit('SHOW_DIALOG_USER_PAY','pay_order')
            return;
        }
    },
    components:{},
    watch:{
        show_dialog(val,old){
            console.log("show_dialog :",val,old);
            if(val){
               if(this.recharge_types.length ==0){
                  this.get_recharge_type();
               }
               this.empty_value();
               // debugger
            }else{
                this.doing = false;
            }
        },
        selected_type(val,old){
            if(val){
                let item = this.recharge_types.find(it=> it._id == val);
                if(item){
                    console.log("Found id:",item);
                    this.money               = item.money;
                    this.ext                 = item.ext;
                    if(!this.note) this.note = item.note;
                    return;
                    
                }
            }
            // this.money = item.money;
            // this.ext = item.ext;
        } 
    },
    directives: {},
    mounted :function(){},
    data () {
        return {
            mobile : "",
            name   : "",
            selected_type:null,
            money  : 0,
            ext    : 0,
            note   : "",
            doing  :false,
            menu   :false,
            recharge_types:[]
        }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.import_input{
  font-size: 24px !important;;
  color:#a94442;
}
</style>



// WEBPACK FOOTER //
// src/views/front_sale/dialogs/dialog_vip_recharge.vue